import { spawn } from 'redux-saga/effects';

import { sagas as bulkUpdateTTLSagas } from './bulkUpdateTTLModule';
import { sagas as delegationSagas } from './delegationModule';
import { sagas as deleteSagas } from './deleteModule';
import { sagas as detailsSagas } from './detailsModule';
import { sagas as formatAsBindSagas } from './formatAsBindModule';
import { sagas as summarySagas } from './summaryModule';
import { sagas as createSaga } from './createModule';
import { sagas as importCpanelZoneSaga } from './importCpanelZoneModule';
import { sagas as importZoneFileSaga } from './importZoneFileModule';
import { sagas as parkableIpsSaga } from './parkableIpsModule';
import historySagas from './history/historySagas';

export default function* zoneSagas() {
	yield spawn(bulkUpdateTTLSagas);
	yield spawn(createSaga);
	yield spawn(delegationSagas);
	yield spawn(deleteSagas);
	yield spawn(detailsSagas);
	yield spawn(formatAsBindSagas);
	yield spawn(historySagas);
	yield spawn(importCpanelZoneSaga);
	yield spawn(importZoneFileSaga);
	yield spawn(parkableIpsSaga);
	yield spawn(summarySagas);
}
